import React from "react";

export default function VizardLoader() {
  return (
    <main className="w-full h-full flex flex-col items-center justify-center">
      {/* <!-- From Uiverse.io by Nawsome -->  */}

      {/* <!-- From Uiverse.io by Nawsome -->  */}
      {/* <div class="loader">
        <div class="loader__bar"></div>
        <div class="loader__bar"></div>
        <div class="loader__bar"></div>
        <div class="loader__bar"></div>
        <div class="loader__bar"></div>
        <div class="loader__ball"></div>
      </div> */}
       <img src="/images/vizardLoader.gif" alt="Loading..." className="w-40 h-40" />
       Visualizing...
    </main>
  );
}
